import { render } from "./VehicleTrunk.vue?vue&type=template&id=76c5ca48"
import script from "./VehicleTrunk.vue?vue&type=script&lang=js"
export * from "./VehicleTrunk.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__